import { render, staticRenderFns } from "./Boekingsoverzicht.vue?vue&type=template&id=be05ae48&scoped=true"
import script from "./Boekingsoverzicht.vue?vue&type=script&lang=js"
export * from "./Boekingsoverzicht.vue?vue&type=script&lang=js"
import style0 from "./Boekingsoverzicht.vue?vue&type=style&index=0&id=be05ae48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be05ae48",
  null
  
)

export default component.exports